import React, { useMemo } from "react";
import { Card, Col, ListGroup, Row } from "react-bootstrap";
import styled from "styled-components";
import ServerErrorModal from "../../organisms/ServerErrorModal";
import LoadingScreen from "../../organisms/LoadingScreen";
import MascotaReporte from "./MascotaReporte";
import { useAutoAnimate } from "@formkit/auto-animate/react";
import CrearReporteModal from "./CrearReporteModal";
import VerReporteModal from "./VerReporteModal";
import {
  MascotaReporteDiario,
  ReporteDiario,
  useObtenerMascotasReporteDiario,
} from "../../../services/reporteDiarioServicios";
import EditarReporteModal from "./EditarReporteModal";
import { useNavigate } from "react-router-dom";

function MascotasReporte() {
  const nagivate = useNavigate();

  const [mascotaSeleccionada, setMascotaSeleccionada] = React.useState<
    MascotaReporteDiario | undefined
  >(undefined);

  const [reporteSeleccionado, setReporteSeleccionado] = React.useState<
    ReporteDiario | undefined
  >(undefined);

  const [envioReporteIsError, setEnvioReporteIsError] =
    React.useState<boolean>(false);

  const [accionMascota, setAccionMascota] = React.useState<
    "VER_REPORTE" | "CREAR_REPORTE" | "EDITAR_REPORTE" | undefined
  >(undefined);

  const [animationParent] = useAutoAnimate<HTMLOListElement>();

  const {
    data: mascotasData,
    isLoading: mascotasIsLoading,
    isError: mascotasIsError,
    isSuccess: mascotasIsSuccess,
  } = useObtenerMascotasReporteDiario();

  const reportesDeMascotas = mascotasData && mascotasIsSuccess ? mascotasData : [];

  const onVerReporteClick = (mascota: MascotaReporteDiario) => {
    setMascotaSeleccionada(mascota);
    setAccionMascota("VER_REPORTE");
  };

  const onCrearReporteClick = (mascota: MascotaReporteDiario) => {
    setMascotaSeleccionada(mascota);
    setAccionMascota("CREAR_REPORTE");
  };

  const onEditarReporteClick = (
    mascota: MascotaReporteDiario,
    reporteDiario: ReporteDiario
  ) => {
    setMascotaSeleccionada(mascota);
    setReporteSeleccionado(reporteDiario);
    setAccionMascota("EDITAR_REPORTE");
  };

  const onCloseReporteModal = () => {
    setMascotaSeleccionada(undefined);
    setAccionMascota(undefined);
    setReporteSeleccionado(undefined);
  };

  const CrearReporteScreen = useMemo(() => {
    if (mascotaSeleccionada && accionMascota === "CREAR_REPORTE") {
      return (
        <CrearReporteModal
          mascota={mascotaSeleccionada}
          onCloseClick={onCloseReporteModal}
        />
      );
    } else {
      return <></>;
    }
  }, [mascotaSeleccionada, accionMascota]);

  const VerReporteScreen = useMemo(() => {
    if (mascotaSeleccionada && accionMascota === "VER_REPORTE") {
      return (
        <VerReporteModal
          mascota={mascotaSeleccionada}
          onCloseClick={onCloseReporteModal}
          onEditarReporteClick={onEditarReporteClick}
        />
      );
    } else {
      return <></>;
    }
  }, [mascotaSeleccionada, accionMascota]);

  const EditarReporteScreen = useMemo(() => {
    if (
      mascotaSeleccionada &&
      reporteSeleccionado &&
      accionMascota === "EDITAR_REPORTE"
    ) {
      return (
        <EditarReporteModal
          mascota={mascotaSeleccionada}
          reporteDiario={reporteSeleccionado}
          onCloseClick={onCloseReporteModal}
        />
      );
    } else {
      return <></>;
    }
  }, [mascotaSeleccionada, reporteSeleccionado, accionMascota]);

  const onCerrarErrorModal = () => {
    if (envioReporteIsError) {
      setEnvioReporteIsError(false);
    }
    if (mascotasIsError) {
      nagivate("/comunicaciones");
    }
  };

  const onEnviarError = () => {
    setEnvioReporteIsError(true);
  };

  const error = mascotasIsError || envioReporteIsError;

  if (error) {
    return <ServerErrorModal onClose={onCerrarErrorModal} />;
  }

  if (mascotasIsLoading) {
    return <LoadingScreen />;
  }

  return (
    <>
      <Card>
        <StyledCardHeader>
          <h5>Listado de reportes diarios por asistencia</h5>
        </StyledCardHeader>
        <Card.Body>
          <Row>
            <Col className="col-12">
              <ListGroup as="ol" numbered ref={animationParent}>
                {reportesDeMascotas.map((reporteDeMascota) => (
                  <MascotaReporte
                    reporteDeMascota={reporteDeMascota}
                    key={reporteDeMascota.idMascota}
                    onVerReporteClick={onVerReporteClick}
                    onCrearReporteClick={onCrearReporteClick}
                    onEnviarError={onEnviarError}
                  />
                ))}
              </ListGroup>
            </Col>
          </Row>
        </Card.Body>
      </Card>
      {CrearReporteScreen}
      {VerReporteScreen}
      {EditarReporteScreen}
    </>
  );
}

export default MascotasReporte;

const StyledCardHeader = styled(Card.Header)`
  border-color: #eaeaea;
  position: relative;
  background: transparent;
  padding: 1.25rem 1.25rem 5px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 0px;
`;
